export default "__VITE_ASSET__DbINgDWV__"